import { render } from "./EditProjectForm.vue?vue&type=template&id=4e2b76e4"
import script from "./EditProjectForm.vue?vue&type=script&lang=js"
export * from "./EditProjectForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/ec2-user/ContentMoverNodejs/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__